module.exports = __webpack_public_path__ + "img/solution-icon-1.f20281be.png";